/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".back-document-scan[_ngcontent-%COMP%]{padding-top:8px}.back-document-scan[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#231d19;font-size:24px;font-weight:300;letter-spacing:0;line-height:32px}.back-document-scan[_ngcontent-%COMP%]   .animation[_ngcontent-%COMP%]{margin:16px 0}.back-document-scan[_ngcontent-%COMP%]   .link[_ngcontent-%COMP%]{margin:0 0 45px 32px}"];
export { styles as styles };
